import { CategoriaEnum } from '@acme/auth'
import Dialog from 'global/guides/Dialog'
import { hasPermission } from 'hooks/useBackendMenu'
import { SubmitHandler } from 'react-hook-form'
import { CreateSupervisorSchema, Supervisor, supervisor } from 'service/api'
import { toast } from 'sonner'
import { Associacoes } from '../forms/Associacoes'
import { SupervisorForm } from '../forms/SupervisorForm'

export default function AdicionarSupervisor() {
    const { mutateAsync, isLoading } = supervisor.mutations.useCreate({
        invalidateQuery: true,
    })

    const handleSubmit: SubmitHandler<Supervisor> = async data =>
        mutateAsync(data, {
            onSuccess: () => {
                toast.success('Supervisor adicionado com sucesso')
            },
            onError: err => {
                toast.error(err.message)
            },
        })

    return (
        <Dialog.Root
            loading={isLoading}
            onSubmit={handleSubmit}
            schema={CreateSupervisorSchema}
            open={hasPermission(['create', 'Supervisores'])}
            defaultValues={{
                Usuario: {
                    categoriaId: CategoriaEnum.Supervisor,
                    perfilPermissaoId: null,
                },
            }}
        >
            <Dialog.Title>Adicionar supervisor</Dialog.Title>
            <Dialog.Content>
                <SupervisorForm />
                <Associacoes />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton closeOnSubmit />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
